import { useSettingsMetaQuery } from 'core/graphql';

type loadMetaType = {
  totalCount: {
    courses: number;
    groups: number;
    journals: number;
  };
};

/**
 * `skip` — for a user who sees none of the counted tabs (FinanceManager on
 * the LMS-suspension settings tab), so the counters are not requested.
 */
export const useLoadMetaHook = (skip = false): loadMetaType => {
  const { data } = useSettingsMetaQuery({ errorPolicy: 'all', skip });

  const result = () => {
    if (!data) {
      return { courses: 0, groups: 0, teachers: 0, journals: 0 };
    }

    return {
      courses: data?.metaCourses?.totalCount || 0,
      groups: data?.metaGroups?.totalCount || 0,
      journals: data?.metaGroups?.totalCount || 0,
    };
  };

  return { totalCount: result() };
};
